import React from 'react';
import { motion } from 'framer-motion';
import { Wallet, Sparkles, HeartHandshake, Wind, Smile, Infinity as InfinityIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ColectieBenefits() {
  const benefits = [{
    icon: Wallet,
    title: 'Îți îmbunătățești relația cu banii',
    desc: 'Înveți să identifici și să schimbi credințele limitative legate de bani. Înțelegi de ce abundența nu venea spre tine și ce trebuie să se schimbe în interior.'
  }, {
    icon: Sparkles,
    title: 'Poți manifesta mai ușor ce îți dorești',
    desc: 'Prin meditații și lucru cu subconștientul, înveți să te conectezi cu o stare din care lucrurile bune vin mai natural în viața ta.'
  }, {
    icon: HeartHandshake,
    title: 'Ai relații mai bune cu tine și cu ceilalți',
    desc: 'Înveți să te iubești pe tine, să ierți, să eliberezi resentimentele și să construiești relații mai armonioase și mai autentice.'
  }, {
    icon: Wind,
    title: 'Înveți să trăiești fără stres constant',
    desc: 'Primești tehnici practice de calmare a minții, respirație și reglare emoțională pe care le poți folosi în orice moment.'
  }, {
    icon: Smile,
    title: 'Devii mai optimist/ă și încrezător/oare',
    desc: 'Pe măsură ce lucrezi cu subconștientul și practici exercițiile zilnice, încrederea în tine crește și perspectiva asupra vieții se schimbă.'
  }, {
    icon: InfinityIcon,
    title: 'Ai acces pe viață la toate materialele',
    desc: 'Cursurile sunt înregistrate și rămân ale tale pentru totdeauna. Le parcurgi în ritmul tău, le revezi ori de câte ori ai nevoie.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-381">
      <div className="max-w-7xl mx-auto px-6" data-id="element-382">
        <SectionHeading title="Care sunt beneficiile Academiei de Abundență" data-id="element-383" />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-384">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="bg-brand-cream rounded-3xl p-8 text-center hover:shadow-warm transition-shadow duration-300 border border-brand-text/5" data-id="element-385">
                <div className="w-16 h-16 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-386">
                  <Icon className="w-8 h-8" data-id="element-387" />
                </div>
                <h3 className="font-bold text-xl text-brand-text mb-4" data-id="element-388">
                  {benefit.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-389">
                  {benefit.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-390">
          <CTAButton data-id="element-391" />
        </motion.div>
      </div>
    </section>;
}